import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, mergeProps as _mergeProps, withModifiers as _withModifiers, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, createSlots as _createSlots, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, vShow as _vShow, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  style: {"width":"400px"},
  class: "d-flex justify-center"
}
const _hoisted_2 = {
  style: {"width":"400px"},
  class: "d-flex justify-center"
}
const _hoisted_3 = { style: {"height":"calc(100vh - 157px)","overflow-y":"auto","border-top-left-radius":"25px","border-top-right-radius":"25px"} }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 2 }
const _hoisted_7 = { key: 3 }
const _hoisted_8 = { key: 4 }
const _hoisted_9 = { key: 5 }
const _hoisted_10 = { key: 6 }
const _hoisted_11 = { key: 7 }
const _hoisted_12 = {
  key: 0,
  style: {"font-weight":"bold","border-right":"1px solid #dddddd"},
  class: "pa-1"
}
const _hoisted_13 = {
  key: 1,
  class: "pa-1"
}
const _hoisted_14 = {
  key: 2,
  style: {"font-weight":"bold","text-align":"right","border-right":"1px solid #dddddd"},
  class: "pa-1"
}
const _hoisted_15 = {
  key: 3,
  style: {"text-align":"right"},
  class: "pa-1"
}
const _hoisted_16 = {
  style: {"width":"24px"},
  class: "text-center pa-1"
}
const _hoisted_17 = {
  key: 4,
  class: "pa-1"
}
const _hoisted_18 = {
  key: 5,
  style: {"min-width":"100px"},
  class: "text-right pa-1"
}
const _hoisted_19 = {
  key: 6,
  style: {"text-align":"right"},
  class: "pa-1"
}
const _hoisted_20 = {
  key: 7,
  style: {"text-align":"right"},
  class: "pa-1"
}
const _hoisted_21 = {
  key: 8,
  style: {"text-align":"center","border-right":"1px solid #dddddd"},
  class: "pa-1"
}
const _hoisted_22 = {
  key: 9,
  style: {"text-align":"right","border-right":"1px solid #dddddd"},
  class: "pa-1"
}
const _hoisted_23 = { class: "text-center pa-1" }
const _hoisted_24 = {
  key: 10,
  style: {"font-weight":"bold","text-align":"right","border-right":"1px solid #dddddd"},
  class: "pa-1"
}
const _hoisted_25 = {
  key: 11,
  style: {"text-align":"right","border-right":"1px solid #dddddd"},
  class: "pa-1"
}
const _hoisted_26 = {
  key: 12,
  class: "pa-1 align-center"
}
const _hoisted_27 = {
  key: 13,
  style: {"text-align":"right"},
  class: "pa-1"
}
const _hoisted_28 = { key: 14 }
const _hoisted_29 = {
  key: 15,
  style: {"text-align":"right"},
  class: "pa-1"
}
const _hoisted_30 = {
  key: 16,
  style: {"text-align":"center"},
  class: "pa-1"
}
const _hoisted_31 = {
  key: 17,
  style: {"text-align":"center"},
  class: "pa-1"
}
const _hoisted_32 = {
  key: 18,
  style: {"text-align":"center"},
  class: "pa-1"
}
const _hoisted_33 = {
  key: 19,
  style: {"text-align":"center"},
  class: "pa-1"
}
const _hoisted_34 = {
  key: 20,
  style: {"font-weight":"bold","text-align":"right"},
  class: "pa-1"
}
const _hoisted_35 = {
  key: 21,
  style: {"text-align":"right"},
  class: "pa-1"
}
const _hoisted_36 = {
  key: 22,
  style: {"font-weight":"bold","text-align":"right","border-right":"1px solid #dddddd"},
  class: "pa-1"
}
const _hoisted_37 = {
  key: 23,
  style: {"text-align":"right","border-right":"1px solid #dddddd"},
  class: "pa-1"
}
const _hoisted_38 = {
  key: 24,
  style: {"text-align":"right"},
  class: "pa-1"
}
const _hoisted_39 = {
  key: 25,
  style: {"text-align":"right"},
  class: "pa-1"
}
const _hoisted_40 = {
  key: 26,
  style: {"font-weight":"bold","text-align":"right"},
  class: "pa-1"
}
const _hoisted_41 = {
  key: 27,
  style: {"text-align":"right"},
  class: "pa-1"
}
const _hoisted_42 = { class: "text-center pa-1" }
const _hoisted_43 = { style: {"font-weight":"bold","color":"black"} }
const _hoisted_44 = { style: {"text-align":"right","border-right":"1px solid #dddddd"} }
const _hoisted_45 = { style: {"text-align":"right"} }
const _hoisted_46 = { style: {"text-align":"right"} }
const _hoisted_47 = { style: {"text-align":"center"} }
const _hoisted_48 = { style: {"text-align":"center"} }
const _hoisted_49 = { style: {"text-align":"right"} }
const _hoisted_50 = { style: {"text-align":"right","border-right":"1px solid #dddddd"} }
const _hoisted_51 = { style: {"text-align":"right"} }
const _hoisted_52 = { style: {"text-align":"right"} }
const _hoisted_53 = { class: "d-flex justify-end" }
const _hoisted_54 = {
  key: 0,
  class: "d-flex align-center"
}
const _hoisted_55 = {
  key: 1,
  class: "d-flex align-center"
}
const _hoisted_56 = { key: 0 }
const _hoisted_57 = {
  key: 1,
  class: "text-primary"
}
const _hoisted_58 = { key: 0 }
const _hoisted_59 = {
  key: 0,
  style: {"font-weight":"bold","border-right":"1px solid #dddddd"},
  class: "pa-1"
}
const _hoisted_60 = {
  style: {"font-weight":"bold","border-right":"1px solid #dddddd"},
  class: "pa-1"
}
const _hoisted_61 = { class: "pl-4" }
const _hoisted_62 = {
  key: 0,
  style: {"margin-top":"15px","margin-bottom":"10px"}
}
const _hoisted_63 = { key: 2 }
const _hoisted_64 = {
  key: 7,
  style: {"margin-top":"40px","margin-bottom":"10px"}
}
const _hoisted_65 = {
  key: 8,
  style: {"margin-top":"10px","margin-bottom":"5px"}
}
const _hoisted_66 = {
  key: 9,
  style: {"color":"#e1be7a"}
}
const _hoisted_67 = {
  key: 10,
  class: "pt-4"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn_back = _resolveComponent("v-btn-back")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn_prev = _resolveComponent("v-btn-prev")!
  const _component_v_btn_next = _resolveComponent("v-btn-next")!
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_oss_text_field_filled = _resolveComponent("oss-text-field-filled")!
  const _component_v_select_filled = _resolveComponent("v-select-filled")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_oss_date_range_picker = _resolveComponent("oss-date-range-picker")!
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_AuditConnectedAcrDocuments = _resolveComponent("AuditConnectedAcrDocuments")!
  const _component_AuditConnectedAcrResults = _resolveComponent("AuditConnectedAcrResults")!
  const _component_GeneralLedger = _resolveComponent("GeneralLedger")!
  const _component_v_expand_transition = _resolveComponent("v-expand-transition")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!
  const _component_UsersActivitiesHistory = _resolveComponent("UsersActivitiesHistory")!
  const _component_AccountingItemEdition2 = _resolveComponent("AccountingItemEdition2")!
  const _component_Chat = _resolveComponent("Chat")!
  const _component_AuditCheckDocumentsManager = _resolveComponent("AuditCheckDocumentsManager")!

  return (_openBlock(), _createBlock(_component_v_container, {
    "grid-list-md": "",
    fluid: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, {
        "no-gutters": "",
        class: "d-flex justify-space-between mb-1"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "7",
            class: "d-flex flex-column"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, { "no-gutters": "" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    cols: "1",
                    class: "d-flex align-center justify-center"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_btn_back, {
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({ name: 'auditReport' })))
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, { cols: "11" }, {
                    default: _withCtx(() => _cache[66] || (_cache[66] = [
                      _createElementVNode("h2", null, "Provisions sur salaires", -1)
                    ])),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_row, { "no-gutters": "" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { cols: "1" }),
                  _createVNode(_component_v_col, { cols: "10" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(`Statut : ${_ctx.checkStatus}`), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, { cols: "5" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, {
                "no-gutters": "",
                class: "d-flex justify-end align-center"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_tooltip, {
                    location: "bottom",
                    text: "Lier un document"
                  }, {
                    activator: _withCtx(({ props }) => [
                      _createVNode(_component_v_btn, _mergeProps({
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.dialogAuditCheckDocumentsManager = true))
                      }, props, {
                        size: "x-small",
                        icon: "$oss-upload",
                        class: "mx-1"
                      }), null, 16)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_tooltip, {
                    location: "bottom",
                    text: "Message"
                  }, {
                    activator: _withCtx(({ props }) => [
                      _createVNode(_component_v_btn, _mergeProps({
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openChat = !_ctx.openChat))
                      }, props, {
                        size: "x-small",
                        icon: "$oss-chat",
                        class: "mx-1"
                      }), null, 16)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_btn, {
                    disabled: 
                            _ctx.closedPeriod || _ctx.validated || _ctx.loading || _ctx.dataLoading || !_ctx.accountingPeriod
                        ,
                    onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.dialog = true), ["stop"])),
                    size: "small",
                    class: "mx-1"
                  }, {
                    default: _withCtx(() => _cache[67] || (_cache[67] = [
                      _createTextVNode(" Enregistrer ")
                    ])),
                    _: 1
                  }, 8, ["disabled"]),
                  _createVNode(_component_v_btn, {
                    disabled: _ctx.closedPeriod || _ctx.loading || _ctx.dataLoading || !_ctx.accountingPeriod,
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.validateFunction())),
                    size: "small",
                    class: "mx-1"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.validated ? "Invalider" : "Valider"), 1)
                    ]),
                    _: 1
                  }, 8, ["disabled"]),
                  (_ctx.isEnableReview)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _cache[68] || (_cache[68] = _createElementVNode("div", { style: {"border-right":"2px solid black","width":"2px","height":"25px","margin":"0 4px"} }, null, -1)),
                        _createVNode(_component_v_icon, {
                          disabled: 
                                _ctx.reviewed === 1 ||
                                !_ctx.isEnableReview ||
                                !_ctx.validated ||
                                _ctx.loading ||
                                _ctx.dataLoading
                            ,
                          size: "small",
                          icon: "$fa-thumbs-up",
                          color: "primary",
                          class: "mx-1",
                          onClick: _cache[5] || (_cache[5] = ($event: any) => {
                                _ctx.reviewed = 1;
                                _ctx.createPaidHolidaysProvision('REVIEW');
                            })
                        }, null, 8, ["disabled"]),
                        _createVNode(_component_v_icon, {
                          disabled: 
                                _ctx.reviewed === -1 ||
                                !_ctx.isEnableReview ||
                                !_ctx.validated ||
                                _ctx.loading ||
                                _ctx.dataLoading
                            ,
                          size: "small",
                          icon: "$fa-thumbs-down",
                          color: "primary",
                          class: "mx-1",
                          onClick: _cache[6] || (_cache[6] = ($event: any) => {
                                _ctx.reviewed = -1;
                                _ctx.createPaidHolidaysProvision('REVIEW');
                            })
                        }, null, 8, ["disabled"]),
                        _cache[69] || (_cache[69] = _createElementVNode("div", { style: {"border-right":"2px solid black","width":"1px","height":"25px","margin":"0 4px"} }, null, -1))
                      ], 64))
                    : _createCommentVNode("", true),
                  _createVNode(_component_v_tooltip, { location: "bottom" }, {
                    activator: _withCtx(({ props }) => [
                      _createVNode(_component_v_btn_prev, _mergeProps(props, {
                        disabled: !_ctx.previousControl,
                        onClick: _cache[7] || (_cache[7] = ($event: any) => {
                                    _ctx.reviewed = 0;
                                    _ctx.openChat = false;
                                    _ctx.goToPreviousControl();
                                })
                      }), null, 16, ["disabled"])
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_1, " Contrôle précédent : " + _toDisplayString(_ctx.previousControl && _ctx.previousControl.title
                                    ? _ctx.previousControl.title
                                    : ""), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_tooltip, { location: "bottom" }, {
                    activator: _withCtx(({ props }) => [
                      _createVNode(_component_v_btn_next, _mergeProps(props, {
                        onClick: _cache[8] || (_cache[8] = ($event: any) => {
                                    _ctx.reviewed = 0;
                                    _ctx.openChat = false;
                                    _ctx.goToNextControl();
                                }),
                        disabled: !_ctx.nextControl
                      }), null, 16, ["disabled"])
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_2, " Contrôle suivant : " + _toDisplayString(_ctx.nextControl && _ctx.nextControl.title ? _ctx.nextControl.title : ""), 1)
                    ]),
                    _: 1
                  }),
                  _cache[74] || (_cache[74] = _createElementVNode("div", { style: {"border-right":"2px solid black","width":"1px","height":"25px","margin":"0 4px"} }, null, -1)),
                  _createVNode(_component_v_menu, { "offset-y": "" }, {
                    activator: _withCtx(({ props }) => [
                      _createVNode(_component_v_btn_icon, _mergeProps({ icon: "$dots_vertical" }, props, {
                        class: "mx-1",
                        color: "secondary"
                      }), null, 16)
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_v_list, { nav: "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item, {
                            onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.displayActivityDialog = true))
                          }, {
                            append: _withCtx(() => [
                              _createVNode(_component_v_icon, null, {
                                default: _withCtx(() => _cache[71] || (_cache[71] = [
                                  _createTextVNode("$oss-activity")
                                ])),
                                _: 1
                              })
                            ]),
                            default: _withCtx(() => [
                              _createVNode(_component_v_list_item_title, null, {
                                default: _withCtx(() => _cache[70] || (_cache[70] = [
                                  _createTextVNode("Afficher l'activité")
                                ])),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_list_item, {
                            disabled: 
                                    _ctx.closedPeriod || !_ctx.auditCheckResult || !_ctx.auditCheckResult.id
                                ,
                            onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.deleteAuditCheckResult(_ctx.auditCheckResult.id)))
                          }, {
                            append: _withCtx(() => [
                              _createVNode(_component_v_icon, { size: "small" }, {
                                default: _withCtx(() => _cache[73] || (_cache[73] = [
                                  _createTextVNode(" $oss-trash ")
                                ])),
                                _: 1
                              })
                            ]),
                            default: _withCtx(() => [
                              _createVNode(_component_v_list_item_title, null, {
                                default: _withCtx(() => _cache[72] || (_cache[72] = [
                                  _createTextVNode(" Supprimer le contrôle ")
                                ])),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["disabled"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_3, [
        (_ctx.loading || _ctx.dataLoading)
          ? (_openBlock(), _createBlock(_component_v_card, {
              key: 0,
              elevation: "0",
              style: {"border-radius":"25px","margin-top":"10px"},
              class: "bg-primary-foreground"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_title, { class: "pa-4 d-flex justify-center" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_progress_circular, {
                      indeterminate: "",
                      class: "mr-3"
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : (!_ctx.accountingPeriod)
            ? (_openBlock(), _createBlock(_component_v_row, {
                key: 1,
                "no-gutters": "",
                class: "d-flex flex-column justify-center align-center mb-3"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, {
                    class: "mr-2 mb-1",
                    size: "large"
                  }, {
                    default: _withCtx(() => _cache[75] || (_cache[75] = [
                      _createTextVNode(" $oss-warning ")
                    ])),
                    _: 1
                  }),
                  _cache[76] || (_cache[76] = _createElementVNode("h3", null, "Aucune période sélectionnée", -1))
                ]),
                _: 1
              }))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                (_ctx.closedPeriod)
                  ? (_openBlock(), _createBlock(_component_v_row, {
                      key: 0,
                      "no-gutters": "",
                      class: "d-flex flex-column justify-center align-center mb-3"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, {
                          class: "mr-2 mb-1",
                          size: "large"
                        }, {
                          default: _withCtx(() => _cache[77] || (_cache[77] = [
                            _createTextVNode(" $oss-warning ")
                          ])),
                          _: 1
                        }),
                        _cache[78] || (_cache[78] = _createElementVNode("h3", null, "Période clôturée", -1))
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.noResults)
                  ? (_openBlock(), _createBlock(_component_v_row, {
                      key: 1,
                      "no-gutters": ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_card_title, {
                              style: {"padding-left":"102px","padding-top":"0"},
                              class: "text-primary"
                            }, {
                              default: _withCtx(() => _cache[79] || (_cache[79] = [
                                _createElementVNode("h4", null, "Aucune écriture enregistrée sur l'exercice fiscal sélectionné", -1)
                              ])),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : (_openBlock(), _createBlock(_component_v_row, {
                      key: 2,
                      "no-gutters": "",
                      style: {"padding-left":"24px","padding-right":"24px"},
                      class: "py-4"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          cols: "auto",
                          class: "mr-auto"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("h3", null, " Salaire brut : " + _toDisplayString(_ctx.newCommonFormatCurrency(_ctx.globalsGrossWages, undefined)), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, {
                          cols: "auto",
                          class: "mx-auto"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("h3", null, " Charges sociales (patronales) : " + _toDisplayString(_ctx.newCommonFormatCurrency(_ctx.globalsEmployersContributions, undefined)), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, {
                          cols: "auto",
                          class: "mx-auto"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("h3", null, "% moyen : " + _toDisplayString(_ctx.globalRateEmployersContribution) + " %", 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, {
                          cols: "auto",
                          class: "ml-auto"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("h3", null, "Base taxes : " + _toDisplayString(_ctx.newCommonFormatCurrency(_ctx.taxeBasis, undefined)), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })),
                (!_ctx.noResults)
                  ? (_openBlock(), _createBlock(_component_v_card, {
                      key: 3,
                      elevation: "0",
                      style: {"border-radius":"25px"},
                      class: "pa-6 mt-4 bg-primary-foreground"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_row, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, {
                              cols: "11",
                              class: "ma-auto"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_card_title, { class: "ma-0 pa-0" }, {
                                  default: _withCtx(() => _cache[80] || (_cache[80] = [
                                    _createElementVNode("h5", { class: "pl-4" }, "Liste des salariés et calcul des provisions", -1)
                                  ])),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_col, {
                              cols: "1",
                              class: "d-flex align-center px-0 justify-center"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_row, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, { cols: "6" }, {
                                      default: _withCtx(() => [
                                        (_ctx.validatedPayrolls)
                                          ? (_openBlock(), _createBlock(_component_v_icon, {
                                              key: 0,
                                              color: "primary"
                                            }, {
                                              default: _withCtx(() => _cache[81] || (_cache[81] = [
                                                _createTextVNode(" $fa-check-circle ")
                                              ])),
                                              _: 1
                                            }))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_col, {
                                      cols: "6",
                                      class: "d-flex align-center pa-0"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_btn_icon, {
                                          icon: _ctx.showPayrolls ? '$fa-chevron-up' : '$fa-chevron-down',
                                          onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.showPayrolls = !_ctx.showPayrolls)),
                                          style: {"width":"40px"},
                                          class: "d-inline px-2"
                                        }, null, 8, ["icon"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        (_ctx.showPayrolls)
                          ? (_openBlock(), _createBlock(_component_v_card_text, {
                              key: 0,
                              transition: "expand"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_data_table, {
                                  headers: _ctx.employeesListHeaders,
                                  items: _ctx.employees,
                                  "sort-by": [{ key: 'employee', order: false }],
                                  "sort-desc": [false, true],
                                  loading: _ctx.loading,
                                  class: "table",
                                  style: {"border":"1px #ededed solid"}
                                }, {
                                  header: _withCtx(({ props: { headers } }) => [
                                    _createElementVNode("thead", null, [
                                      _createElementVNode("tr", null, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(headers, (h, index) => {
                                          return (_openBlock(), _createElementBlock("th", { key: index }, [
                                            _createVNode(_component_v_tooltip, { location: "bottom" }, _createSlots({
                                              default: _withCtx(() => [
                                                (h.text === 'SN')
                                                  ? (_openBlock(), _createElementBlock("span", _hoisted_4, " Salaires nets réels "))
                                                  : _createCommentVNode("", true),
                                                (h.text === 'Estimés Réels')
                                                  ? (_openBlock(), _createElementBlock("span", _hoisted_5, _cache[82] || (_cache[82] = [
                                                      _createElementVNode("p", null, " Estimé est adapté à des salariés présents sur des mois entiers, tous avec, environ, les même taux de cotisations patronales (pas d'apprentis). ", -1),
                                                      _createElementVNode("p", null, " Réel rend nécessaire la saisie des 3 champs affichés. ", -1)
                                                    ])))
                                                  : _createCommentVNode("", true),
                                                (h.text === 'SB')
                                                  ? (_openBlock(), _createElementBlock("span", _hoisted_6, " Salaires bruts estimés ou réels "))
                                                  : _createCommentVNode("", true),
                                                (h.text === 'CS')
                                                  ? (_openBlock(), _createElementBlock("span", _hoisted_7, " Cotisations sociales patronales "))
                                                  : _createCommentVNode("", true),
                                                (h.text === 'CP acquis N')
                                                  ? (_openBlock(), _createElementBlock("span", _hoisted_8, " Congés payés acquis pendant la période calculée "))
                                                  : _createCommentVNode("", true),
                                                (h.text === '%')
                                                  ? (_openBlock(), _createElementBlock("span", _hoisted_9, " Taux de cotisations patronales, selon l'option choisie : estimé ou réel "))
                                                  : _createCommentVNode("", true),
                                                (h.text === '1 CP')
                                                  ? (_openBlock(), _createElementBlock("span", _hoisted_10, " Valeur unitaire d'un jour de congé payé, calculé selon la méthode du 10% "))
                                                  : _createCommentVNode("", true),
                                                (h.text === 'Prov. CP/RTT')
                                                  ? (_openBlock(), _createElementBlock("span", _hoisted_11, " Calcul au 10% "))
                                                  : _createCommentVNode("", true)
                                              ]),
                                              _: 2
                                            }, [
                                              (
                                                        h.text === 'SN' ||
                                                        h.text === 'Estimés Réels' ||
                                                        h.text === 'SB' ||
                                                        h.text === 'CS' ||
                                                        h.text === 'CP acquis N' ||
                                                        h.text === '%' ||
                                                        h.text === '1 CP' ||
                                                        h.text === 'Prov. CP/RTT'
                                                    )
                                                ? {
                                                    name: "activator",
                                                    fn: _withCtx(({ props }) => [
                                                      _createElementVNode("span", _mergeProps({ ref_for: true }, props), _toDisplayString(h.text), 17)
                                                    ]),
                                                    key: "0"
                                                  }
                                                : {
                                                    name: "activator",
                                                    fn: _withCtx(({ props }) => [
                                                      _createElementVNode("span", _mergeProps({ ref_for: true }, props), _toDisplayString(h.text), 17)
                                                    ]),
                                                    key: "1"
                                                  }
                                            ]), 1024)
                                          ]))
                                        }), 128))
                                      ])
                                    ])
                                  ]),
                                  "no-data": _withCtx(() => _cache[83] || (_cache[83] = [
                                    _createTextVNode(" Aucun bulletin de salaire saisi au cours de l'exercice ")
                                  ])),
                                  item: _withCtx((props) => [
                                    _createElementVNode("tr", null, [
                                      (props.item.employee)
                                        ? (_openBlock(), _createElementBlock("td", _hoisted_12, _toDisplayString(props.item.employee.lastName) + " " + _toDisplayString(props.item.employee.firstName), 1))
                                        : (_openBlock(), _createElementBlock("td", _hoisted_13, "-")),
                                      (props.item.netSalarySum)
                                        ? (_openBlock(), _createElementBlock("td", _hoisted_14, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                props.item.netSalarySum,
                                                undefined,
                                            )), 1))
                                        : (_openBlock(), _createElementBlock("td", _hoisted_15, "-")),
                                      _createElementVNode("td", _hoisted_16, [
                                        _createVNode(_component_v_checkbox, {
                                          modelValue: props.item.approxOrRealSwitch,
                                          "onUpdate:modelValue": ($event: any) => ((props.item.approxOrRealSwitch) = $event),
                                          disabled: props.item.validated,
                                          dense: "",
                                          color: "primary",
                                          "hide-details": "",
                                          width: "24px",
                                          class: "d-inline-flex pa-0 ma-0",
                                          onChange: ($event: any) => (_ctx.changeProvision(props.item))
                                        }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "onChange"])
                                      ]),
                                      (props.item.approxOrRealSwitch)
                                        ? (_openBlock(), _createElementBlock("td", _hoisted_17, [
                                            _createVNode(_component_oss_text_field_filled, {
                                              modelValue: props.item.realGrossWages,
                                              "onUpdate:modelValue": [($event: any) => ((props.item.realGrossWages) = $event), ($event: any) => (_ctx.changeProvision(props.item))],
                                              disabled: props.item.validated,
                                              rules: [(v) => parseFloat(v) > 0 || 'Min 0'],
                                              style: {"margin-right":"auto","margin-left":"auto","display":"inline-block","width":"100px","text-align":"right"},
                                              "content-class": "text_field_tag",
                                              autofocus: "",
                                              required: "",
                                              suffix: '',
                                              hideDetails: false
                                            }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "rules"])
                                          ]))
                                        : (props.item.grossWagesApprox)
                                          ? (_openBlock(), _createElementBlock("td", _hoisted_18, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                props.item.grossWagesApprox,
                                                undefined,
                                            )), 1))
                                          : _createCommentVNode("", true),
                                      (props.item.approxOrRealSwitch)
                                        ? (_openBlock(), _createElementBlock("td", _hoisted_19, [
                                            _createVNode(_component_oss_text_field_filled, {
                                              modelValue: props.item.realEmployerContributions,
                                              "onUpdate:modelValue": [($event: any) => ((props.item.realEmployerContributions) = $event), ($event: any) => (_ctx.changeProvision(props.item))],
                                              disabled: props.item.validated,
                                              rules: [(v) => parseFloat(v) > 0 || 'Min 0'],
                                              style: {"margin-right":"auto","margin-left":"auto","display":"inline-block","width":"100px","text-align":"right"},
                                              "content-class": "text_field_tag",
                                              autofocus: "",
                                              required: "",
                                              suffix: '',
                                              hideDetails: false
                                            }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "rules"])
                                          ]))
                                        : (_openBlock(), _createElementBlock("td", _hoisted_20, "-")),
                                      (props.item.approxOrRealSwitch)
                                        ? (_openBlock(), _createElementBlock("td", _hoisted_21, [
                                            _createVNode(_component_oss_text_field_filled, {
                                              modelValue: props.item.realEarnedPaidHolidays,
                                              "onUpdate:modelValue": [($event: any) => ((props.item.realEarnedPaidHolidays) = $event), ($event: any) => (_ctx.changeProvision(props.item))],
                                              disabled: props.item.validated,
                                              style: {"margin-right":"auto","margin-left":"auto","width":"60px"},
                                              min: "0",
                                              max: "60",
                                              "content-class": "text_field_tag",
                                              autofocus: "",
                                              rules: [(v) => parseFloat(v) > 0 || 'Min 0'],
                                              required: ""
                                            }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "rules"])
                                          ]))
                                        : (_openBlock(), _createElementBlock("td", _hoisted_22, " - ")),
                                      _createElementVNode("td", _hoisted_23, [
                                        _createVNode(_component_v_checkbox, {
                                          modelValue: props.item.apprentice,
                                          "onUpdate:modelValue": ($event: any) => ((props.item.apprentice) = $event),
                                          disabled: props.item.validated,
                                          color: "primary",
                                          "hide-details": "",
                                          class: "d-inline-flex pa-0 ma-0",
                                          onChange: _cache[12] || (_cache[12] = ($event: any) => (_ctx.changeTaxesProvision()))
                                        }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
                                      ]),
                                      (props.item.usedRate)
                                        ? (_openBlock(), _createElementBlock("td", _hoisted_24, _toDisplayString(props.item.usedRate) + "% ", 1))
                                        : (_openBlock(), _createElementBlock("td", _hoisted_25, " - ")),
                                      (
                                            props.item.daysTypes && !props.item.approxOrRealSwitch
                                        )
                                        ? (_openBlock(), _createElementBlock("td", _hoisted_26, [
                                            _createVNode(_component_v_select_filled, {
                                              modelValue: props.item.daysTypes,
                                              "onUpdate:modelValue": [($event: any) => ((props.item.daysTypes) = $event), ($event: any) => (_ctx.changeProvision(props.item))],
                                              disabled: props.item.validated,
                                              items: _ctx.workingBusinessDays,
                                              style: {"width":"90px"},
                                              required: "",
                                              density: "compact"
                                            }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "items"])
                                          ]))
                                        : (_openBlock(), _createElementBlock("td", _hoisted_27)),
                                      (props.item.oneDayGrossWage)
                                        ? (_openBlock(), _createElementBlock("td", _hoisted_28, [
                                            (
                                                props.item.approxOrRealSwitch &&
                                                (!props.item.realGrossWages ||
                                                    !props.item.realEmployerContributions ||
                                                    !props.item.realEarnedPaidHolidays)
                                            )
                                              ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                                  key: 0,
                                                  location: "bottom",
                                                  text: "En cas de saisie réelle, les 3 champs SB + CS + CP\n                                                    acquis N sont nécessaires au calcul"
                                                }, {
                                                  activator: _withCtx(({ props: tooltipProps }) => [
                                                    _createElementVNode("span", _normalizeProps(_guardReactiveProps(tooltipProps)), "-", 16)
                                                  ]),
                                                  _: 1
                                                }))
                                              : (props.item.approxOrRealSwitch)
                                                ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                                    key: 1,
                                                    location: "bottom",
                                                    text: "SB réel * 10% / CP acquis"
                                                  }, {
                                                    activator: _withCtx(({ props: tooltipProps }) => [
                                                      _createElementVNode("span", _normalizeProps(_guardReactiveProps(tooltipProps)), _toDisplayString(_ctx.newCommonFormatCurrency(
                                                                props.item.oneDayGrossWage,
                                                                undefined,
                                                            )), 17)
                                                    ]),
                                                    _: 2
                                                  }, 1024))
                                                : (_openBlock(), _createBlock(_component_v_tooltip, {
                                                    key: 2,
                                                    location: "bottom",
                                                    text: "SB approx * 10% / (nb bulletins / 12) / (25 ou\n                                                    30)"
                                                  }, {
                                                    activator: _withCtx(({ props: tooltipProps }) => [
                                                      _createElementVNode("span", _normalizeProps(_guardReactiveProps(tooltipProps)), _toDisplayString(_ctx.newCommonFormatCurrency(
                                                                props.item.oneDayGrossWage,
                                                                undefined,
                                                            )), 17)
                                                    ]),
                                                    _: 2
                                                  }, 1024))
                                          ]))
                                        : (_openBlock(), _createElementBlock("td", _hoisted_29, "-")),
                                      (props.item.balancePaidHolidays >= 0)
                                        ? (_openBlock(), _createElementBlock("td", _hoisted_30, [
                                            _createVNode(_component_oss_text_field_filled, {
                                              modelValue: props.item.balancePaidHolidays,
                                              "onUpdate:modelValue": ($event: any) => ((props.item.balancePaidHolidays) = $event),
                                              disabled: props.item.validated,
                                              style: {"margin-right":"auto","margin-left":"auto","width":"60px"},
                                              min: "0",
                                              max: "60",
                                              error: props.item.balancePaidHolidays < 0,
                                              "content-class": "text_field_tag",
                                              autofocus: "",
                                              onChange: ($event: any) => (_ctx.changeProvision(props.item))
                                            }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "error", "onChange"])
                                          ]))
                                        : (_openBlock(), _createElementBlock("td", _hoisted_31, "-")),
                                      (props.item.balanceRTT >= 0)
                                        ? (_openBlock(), _createElementBlock("td", _hoisted_32, [
                                            _createVNode(_component_oss_text_field_filled, {
                                              modelValue: props.item.balanceRTT,
                                              "onUpdate:modelValue": ($event: any) => ((props.item.balanceRTT) = $event),
                                              disabled: props.item.validated,
                                              style: {"margin-right":"auto","margin-left":"auto","width":"60px"},
                                              min: "0",
                                              max: "60",
                                              error: props.item.balanceRTT < 0,
                                              "content-class": "text_field_tag",
                                              autofocus: "",
                                              onChange: ($event: any) => (_ctx.changeProvision(props.item))
                                            }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "error", "onChange"])
                                          ]))
                                        : (_openBlock(), _createElementBlock("td", _hoisted_33, "-")),
                                      (props.item.grossWageProvision)
                                        ? (_openBlock(), _createElementBlock("td", _hoisted_34, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                props.item.grossWageProvision,
                                                undefined,
                                            )), 1))
                                        : (_openBlock(), _createElementBlock("td", _hoisted_35, "-")),
                                      (props.item.employerContribProvOnGrossWage)
                                        ? (_openBlock(), _createElementBlock("td", _hoisted_36, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                props.item.employerContribProvOnGrossWage,
                                                undefined,
                                            )), 1))
                                        : (_openBlock(), _createElementBlock("td", _hoisted_37, " - ")),
                                      (props.item.bonus >= 0)
                                        ? (_openBlock(), _createElementBlock("td", _hoisted_38, [
                                            _createVNode(_component_oss_text_field_filled, {
                                              modelValue: props.item.bonus,
                                              "onUpdate:modelValue": ($event: any) => ((props.item.bonus) = $event),
                                              disabled: props.item.validated,
                                              style: {"width":"100px","margin-right":"auto","margin-left":"auto"},
                                              min: "0",
                                              error: props.item.bonus < 0,
                                              "content-class": "text_field_tag",
                                              autofocus: "",
                                              suffix: '',
                                              onChange: ($event: any) => (_ctx.changeProvision(props.item))
                                            }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "error", "onChange"])
                                          ]))
                                        : (_openBlock(), _createElementBlock("td", _hoisted_39, "-")),
                                      (props.item.employerContribProvOnBonus)
                                        ? (_openBlock(), _createElementBlock("td", _hoisted_40, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                props.item.employerContribProvOnBonus,
                                                undefined,
                                            )), 1))
                                        : (_openBlock(), _createElementBlock("td", _hoisted_41, "-")),
                                      _createElementVNode("td", _hoisted_42, [
                                        _createVNode(_component_v_checkbox, {
                                          modelValue: props.item.validated,
                                          "onUpdate:modelValue": ($event: any) => ((props.item.validated) = $event),
                                          disabled: _ctx.validatedPayrolls || _ctx.validated,
                                          color: "primary",
                                          "hide-details": "",
                                          class: "d-inline-flex pa-0 ma-0",
                                          onChange: _cache[13] || (_cache[13] = ($event: any) => (_ctx.changeTaxesProvision()))
                                        }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
                                      ])
                                    ])
                                  ]),
                                  "body.append": _withCtx(() => [
                                    _createElementVNode("tr", _hoisted_43, [
                                      _cache[84] || (_cache[84] = _createElementVNode("th", { style: {"text-align":"left","border-right":"1px solid #dddddd"} }, " Totaux ", -1)),
                                      _createElementVNode("th", _hoisted_44, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                _ctx.sumField("netSalarySum"),
                                                undefined,
                                            )), 1),
                                      _cache[85] || (_cache[85] = _createElementVNode("th", null, null, -1)),
                                      _createElementVNode("th", _hoisted_45, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                _ctx.sumFieldGrossWages("approxOrRealSwitch"),
                                                undefined,
                                            )), 1),
                                      _createElementVNode("th", _hoisted_46, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                _ctx.sumFieldEmployerContributions("approxOrRealSwitch"),
                                                undefined,
                                            )), 1),
                                      _cache[86] || (_cache[86] = _createElementVNode("th", { style: {"border-right":"1px solid #dddddd"} }, null, -1)),
                                      _cache[87] || (_cache[87] = _createElementVNode("th", null, null, -1)),
                                      _cache[88] || (_cache[88] = _createElementVNode("th", null, null, -1)),
                                      _cache[89] || (_cache[89] = _createElementVNode("th", null, null, -1)),
                                      _cache[90] || (_cache[90] = _createElementVNode("th", null, null, -1)),
                                      _createElementVNode("th", _hoisted_47, _toDisplayString(_ctx.sumField("balancePaidHolidays")), 1),
                                      _createElementVNode("th", _hoisted_48, _toDisplayString(_ctx.sumField("balanceRTT")), 1),
                                      _createElementVNode("th", _hoisted_49, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                _ctx.sumField("grossWageProvision"),
                                                undefined,
                                            )), 1),
                                      _createElementVNode("th", _hoisted_50, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                _ctx.sumField("employerContribProvOnGrossWage"),
                                                undefined,
                                            )), 1),
                                      _createElementVNode("th", _hoisted_51, _toDisplayString(_ctx.newCommonFormatCurrency(_ctx.sumField("bonus"), undefined)), 1),
                                      _createElementVNode("th", _hoisted_52, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                _ctx.sumField("employerContribProvOnBonus"),
                                                undefined,
                                            )), 1),
                                      _cache[91] || (_cache[91] = _createElementVNode("th", null, null, -1))
                                    ])
                                  ]),
                                  _: 1
                                }, 8, ["headers", "items", "loading"]),
                                _createVNode(_component_v_row, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, { class: "pb-5" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_card_title, {
                                          style: {"padding-top":"20px","padding-bottom":"0","padding-left":"0"},
                                          class: "d-flex justify-space-between"
                                        }, {
                                          default: _withCtx(() => [
                                            _cache[96] || (_cache[96] = _createElementVNode("h5", null, "Commentaires", -1)),
                                            _createElementVNode("div", _hoisted_53, [
                                              _createVNode(_component_v_btn, {
                                                disabled: 
                                                _ctx.validatedPayrolls || _ctx.closedPeriod || _ctx.validated
                                            ,
                                                onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.miscellaneousOperationDialog = true)),
                                                size: "small"
                                              }, {
                                                default: _withCtx(() => _cache[92] || (_cache[92] = [
                                                  _createTextVNode(" OD ")
                                                ])),
                                                _: 1
                                              }, 8, ["disabled"]),
                                              _createVNode(_component_v_btn, {
                                                disabled: 
                                                _ctx.validatedPayrolls || _ctx.closedPeriod || _ctx.validated
                                            ,
                                                class: "ml-2",
                                                onClick: _cache[15] || (_cache[15] = _withModifiers(($event: any) => (_ctx.dialog = true), ["stop"])),
                                                size: "small"
                                              }, {
                                                default: _withCtx(() => _cache[93] || (_cache[93] = [
                                                  _createTextVNode(" Enregistrer ")
                                                ])),
                                                _: 1
                                              }, 8, ["disabled"]),
                                              (!_ctx.validatedPayrolls)
                                                ? (_openBlock(), _createBlock(_component_v_btn, {
                                                    key: 0,
                                                    disabled: _ctx.closedPeriod || _ctx.validated,
                                                    class: "ml-2",
                                                    onClick: _cache[16] || (_cache[16] = ($event: any) => {
                                                _ctx.validatedPayrolls = !_ctx.validatedPayrolls;
                                                _ctx.createPaidHolidaysProvision('VALIDATE');
                                            }),
                                                    size: "small"
                                                  }, {
                                                    default: _withCtx(() => _cache[94] || (_cache[94] = [
                                                      _createTextVNode(" Valider les salariés ")
                                                    ])),
                                                    _: 1
                                                  }, 8, ["disabled"]))
                                                : (_openBlock(), _createBlock(_component_v_btn, {
                                                    key: 1,
                                                    modelValue: _ctx.validatedPayrolls,
                                                    "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.validatedPayrolls) = $event)),
                                                    disabled: _ctx.closedPeriod || _ctx.validated,
                                                    class: "ml-2",
                                                    onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.invalidate())),
                                                    size: "small"
                                                  }, {
                                                    default: _withCtx(() => _cache[95] || (_cache[95] = [
                                                      _createTextVNode(" Invalider les salariés ")
                                                    ])),
                                                    _: 1
                                                  }, 8, ["modelValue", "disabled"]))
                                            ])
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_row, {
                                  "no-gutters": "",
                                  style: {"padding-top":"0"}
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, { style: {"padding-top":"0"} }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_card_text, { style: {"padding":"0"} }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_textarea, {
                                              modelValue: _ctx.commentEmployees,
                                              "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.commentEmployees) = $event)),
                                              disabled: _ctx.closedPeriod || _ctx.validated,
                                              "auto-grow": "",
                                              style: {"border":"1px #ededed solid"}
                                            }, null, 8, ["modelValue", "disabled"])
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (!_ctx.noResults)
                  ? (_openBlock(), _createBlock(_component_v_card, {
                      key: 4,
                      elevation: "0",
                      style: {"background-color":"white","border-radius":"25px"},
                      class: "pa-6 mt-4"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_row, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, {
                              cols: "11",
                              class: "ma-auto"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_card_title, { class: "ma-0 pa-0" }, {
                                  default: _withCtx(() => _cache[97] || (_cache[97] = [
                                    _createElementVNode("h5", { class: "pl-4" }, "Taxes", -1)
                                  ])),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_col, {
                              cols: "1",
                              class: "d-flex align-center px-0 justify-center"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_row, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, { cols: "6" }, {
                                      default: _withCtx(() => [
                                        (_ctx.validatedTaxes)
                                          ? (_openBlock(), _createBlock(_component_v_icon, {
                                              key: 0,
                                              color: "primary"
                                            }, {
                                              default: _withCtx(() => _cache[98] || (_cache[98] = [
                                                _createTextVNode(" $fa-check-circle ")
                                              ])),
                                              _: 1
                                            }))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_col, {
                                      cols: "6",
                                      class: "d-flex align-center pa-0"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_btn_icon, {
                                          icon: _ctx.showTaxes ? '$fa-chevron-up' : '$fa-chevron-down',
                                          onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.showTaxes = !_ctx.showTaxes)),
                                          style: {"width":"40px"},
                                          class: "d-inline px-2"
                                        }, null, 8, ["icon"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _withDirectives(_createVNode(_component_v_card_text, { transition: "expand" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_card_title, { class: "pa-0" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_row, { "no-gutters": "" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, { class: "d-flex align-center" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_card_title, { class: "px-0" }, {
                                          default: _withCtx(() => [
                                            (_ctx.dates.length === 2 && _ctx.differentsDates)
                                              ? (_openBlock(), _createElementBlock("h4", _hoisted_54, " Période de calcul des taxes s/salaires : du " + _toDisplayString(_ctx.formatDate(_ctx.dates[0])) + " au " + _toDisplayString(_ctx.formatDate(_ctx.dates[1])), 1))
                                              : (
                                                _ctx.accountingPeriod &&
                                                _ctx.accountingPeriod.start &&
                                                _ctx.accountingPeriod.end
                                            )
                                                ? (_openBlock(), _createElementBlock("h4", _hoisted_55, " Période du " + _toDisplayString(_ctx.formatDate(_ctx.accountingPeriod.start)) + " au " + _toDisplayString(_ctx.formatDate(_ctx.accountingPeriod.end)), 1))
                                                : _createCommentVNode("", true)
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_col, { class: "d-flex align-center pl-2" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_menu, {
                                          ref: "datesShow",
                                          modelValue: _ctx.datesShow,
                                          "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.datesShow) = $event)),
                                          "close-on-content-click": false,
                                          transition: "scale-transition",
                                          "offset-y": "",
                                          "min-width": "auto"
                                        }, {
                                          activator: _withCtx(({ props }) => [
                                            _createVNode(_component_v_btn, _mergeProps(props, { icon: "$oss-calendar" }), null, 16)
                                          ]),
                                          default: _withCtx(() => [
                                            _createVNode(_component_oss_date_range_picker, {
                                              begin: _ctx.dates[0],
                                              end: _ctx.dates[1],
                                              disabled: _ctx.closedPeriod || _ctx.validated,
                                              onChangeDateRange: _ctx.onDateRangeChanged,
                                              hideDetails: true
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_spacer)
                                              ]),
                                              _: 1
                                            }, 8, ["begin", "end", "disabled", "onChangeDateRange"])
                                          ]),
                                          _: 1
                                        }, 8, ["modelValue"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_col, { class: "d-flex align-center" }, {
                                      default: _withCtx(() => [
                                        (
                                            _ctx.globalsGrossWages &&
                                            _ctx.dates &&
                                            _ctx.dates[0] === _ctx.formatDatePicker(_ctx.accountingPeriod.start) &&
                                            _ctx.dates[1] === _ctx.formatDatePicker(_ctx.accountingPeriod.end)
                                        )
                                          ? (_openBlock(), _createElementBlock("h5", _hoisted_56, " SB : " + _toDisplayString(_ctx.newCommonFormatCurrency(_ctx.globalsGrossWages, undefined)), 1))
                                          : (_openBlock(), _createElementBlock("h5", _hoisted_57, " SB période : " + _toDisplayString(_ctx.newCommonFormatCurrency(
                                                _ctx.taxesPeriodGrossWages,
                                                undefined,
                                            )), 1))
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_col, {
                                      cols: "auto",
                                      class: "d-flex align-center"
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("h5", null, " Base taxes (SB - SB apprentis) : " + _toDisplayString(_ctx.newCommonFormatCurrency(_ctx.taxeBasis, undefined)), 1)
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            (!_ctx.newPeriodApprentices)
                              ? (_openBlock(), _createBlock(_component_v_card_text, {
                                  key: 0,
                                  class: "pa-0"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_row, { class: "pt-4 pb-6" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_col, { style: {"padding-top":"0","padding-bottom":"0"} }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_card_title, { class: "px-0" }, {
                                              default: _withCtx(() => _cache[99] || (_cache[99] = [
                                                _createElementVNode("h4", { class: "text-primary" }, "Pas d'apprentis sur la période", -1)
                                              ])),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }))
                              : (_openBlock(), _createBlock(_component_v_card_text, {
                                  key: 1,
                                  class: "pa-0"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_data_table, {
                                      headers: _ctx.apprenticesHeaders,
                                      items: _ctx.employees,
                                      "sort-by": [{ key: 'employee', order: false }],
                                      "sort-desc": [false, true],
                                      loading: _ctx.loading,
                                      class: "table",
                                      style: {"border":"1px #ededed solid"}
                                    }, {
                                      "no-data": _withCtx(() => _cache[100] || (_cache[100] = [
                                        _createTextVNode("Aucun bulletin de salaire saisi au cours de l'exercice")
                                      ])),
                                      item: _withCtx((props) => [
                                        (props.item.apprentice)
                                          ? (_openBlock(), _createElementBlock("tr", _hoisted_58, [
                                              (props.item.employee)
                                                ? (_openBlock(), _createElementBlock("td", _hoisted_59, _toDisplayString(props.item.employee.lastName) + " " + _toDisplayString(props.item.employee.firstName), 1))
                                                : _createCommentVNode("", true),
                                              _createElementVNode("td", _hoisted_60, [
                                                _createVNode(_component_oss_text_field_filled, {
                                                  modelValue: props.item.grossWageInNewPeriod,
                                                  "onUpdate:modelValue": [
                                                    ($event: any) => ((props.item.grossWageInNewPeriod) = $event),
                                                    _cache[22] || (_cache[22] = ($event: any) => (_ctx.changeTaxesProvision()))
                                                  ],
                                                  disabled: _ctx.validatedTaxes,
                                                  style: {"margin-right":"auto","margin-left":"auto","display":"inline-block","width":"100px","text-align":"right"},
                                                  "content-class": "text_field_tag",
                                                  autofocus: "",
                                                  rules: [(v) => parseFloat(v) > 0 || 'Min 0'],
                                                  required: "",
                                                  suffix: '',
                                                  hideDetails: false
                                                }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "rules"])
                                              ])
                                            ]))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 1
                                    }, 8, ["headers", "items", "loading"])
                                  ]),
                                  _: 1
                                })),
                            _createVNode(_component_v_card_title, { class: "pa-0" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_row, { class: "pb-4" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_switch, {
                                          modelValue: _ctx.taxeApprentissage,
                                          "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.taxeApprentissage) = $event)),
                                          disabled: _ctx.closedPeriod || _ctx.validated,
                                          label: `Taxe Apprentissage`,
                                          style: {},
                                          class: "ml-2",
                                          onChange: _cache[24] || (_cache[24] = ($event: any) => (_ctx.changeTaxesProvision()))
                                        }, null, 8, ["modelValue", "disabled"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_col, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_switch, {
                                          modelValue: _ctx.taxeSurLesSalaires,
                                          "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.taxeSurLesSalaires) = $event)),
                                          disabled: _ctx.closedPeriod || _ctx.validated,
                                          label: 'Taxe Salaires',
                                          style: {},
                                          class: "ml-2",
                                          onChange: _cache[26] || (_cache[26] = ($event: any) => (_ctx.changeTaxesProvision()))
                                        }, null, 8, ["modelValue", "disabled"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_col, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_switch, {
                                          modelValue: _ctx.contributionUniqueALaFormation,
                                          "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.contributionUniqueALaFormation) = $event)),
                                          disabled: _ctx.closedPeriod || _ctx.validated,
                                          label: 'Contrib. Unique Formation',
                                          style: {},
                                          class: "ml-2",
                                          onChange: _cache[28] || (_cache[28] = ($event: any) => (_ctx.changeTaxesProvision()))
                                        }, null, 8, ["modelValue", "disabled"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_col, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_switch, {
                                          modelValue: _ctx.contributionEffortConstruction,
                                          "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.contributionEffortConstruction) = $event)),
                                          disabled: _ctx.closedPeriod || _ctx.validated,
                                          label: `Contrib. Effort Constr.`,
                                          style: {},
                                          class: "ml-2",
                                          onChange: _cache[30] || (_cache[30] = ($event: any) => (_ctx.changeTaxesProvision()))
                                        }, null, 8, ["modelValue", "disabled"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            (
                                _ctx.taxeApprentissage === true ||
                                _ctx.taxeSurLesSalaires === true ||
                                _ctx.contributionUniqueALaFormation === true ||
                                _ctx.contributionEffortConstruction === true
                            )
                              ? (_openBlock(), _createBlock(_component_v_card_title, {
                                  key: 2,
                                  class: "pa-0"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_row, { class: "pb-2" }, {
                                      default: _withCtx(() => [
                                        (_ctx.taxeApprentissage === true)
                                          ? (_openBlock(), _createBlock(_component_v_col, {
                                              key: 0,
                                              class: "mr-4"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_row, null, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_col, null, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_oss_text_field_filled, {
                                                          modelValue: _ctx.taxeApprentissageRate,
                                                          "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.taxeApprentissageRate) = $event)),
                                                          disabled: _ctx.closedPeriod || _ctx.validated,
                                                          suffix: "%",
                                                          label: "Taxe d'Apprentissage",
                                                          class: "mx-auto",
                                                          "content-class": "text_field_tag",
                                                          autofocus: "",
                                                          onChange: _cache[32] || (_cache[32] = ($event: any) => (_ctx.changeTaxesProvision()))
                                                        }, null, 8, ["modelValue", "disabled"])
                                                      ]),
                                                      _: 1
                                                    }),
                                                    _createVNode(_component_v_col, { class: "d-flex justify-end align-center" }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(_ctx.newCommonFormatCurrency(
                                                    _ctx.taxeApprentissageAmount,
                                                    undefined,
                                                )), 1)
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                }),
                                                _createVNode(_component_v_row, null, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_col, null, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_oss_text_field_filled, {
                                                          modelValue: 
                                                    _ctx.contributionSupplementaireALApprentissageRate
                                                ,
                                                          "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((
                                                    _ctx.contributionSupplementaireALApprentissageRate
                                                ) = $event)),
                                                          disabled: _ctx.closedPeriod || _ctx.validated,
                                                          suffix: "%",
                                                          label: "Contr. Suppl. Apprent.",
                                                          class: "mx-auto",
                                                          "content-class": "text_field_tag",
                                                          autofocus: "",
                                                          onChange: _cache[34] || (_cache[34] = ($event: any) => (_ctx.changeTaxesProvision()))
                                                        }, null, 8, ["modelValue", "disabled"])
                                                      ]),
                                                      _: 1
                                                    }),
                                                    _createVNode(_component_v_col, { class: "d-flex justify-end align-center" }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(_ctx.newCommonFormatCurrency(
                                                    _ctx.contributionSupplementaireALApprentissageAmount,
                                                    undefined,
                                                )), 1)
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            }))
                                          : (_openBlock(), _createBlock(_component_v_col, { key: 1 })),
                                        (_ctx.taxeSurLesSalaires === true)
                                          ? (_openBlock(), _createBlock(_component_v_col, {
                                              key: 2,
                                              class: "mx-4"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_row, null, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_col, null, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_oss_text_field_filled, {
                                                          modelValue: _ctx.taxeSurLesSalairesRate,
                                                          "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.taxeSurLesSalairesRate) = $event)),
                                                          disabled: _ctx.closedPeriod || _ctx.validated,
                                                          suffix: "%",
                                                          label: "Taxe sur les Salaires",
                                                          class: "mx-auto",
                                                          "content-class": "text_field_tag",
                                                          autofocus: "",
                                                          onChange: _cache[36] || (_cache[36] = ($event: any) => (_ctx.changeTaxesProvision()))
                                                        }, null, 8, ["modelValue", "disabled"])
                                                      ]),
                                                      _: 1
                                                    }),
                                                    _createVNode(_component_v_col, { class: "d-flex justify-end align-center" }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(_ctx.newCommonFormatCurrency(
                                                    _ctx.taxeSurLesSalairesAmount,
                                                    undefined,
                                                )), 1)
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            }))
                                          : (_openBlock(), _createBlock(_component_v_col, { key: 3 })),
                                        (_ctx.contributionUniqueALaFormation === true)
                                          ? (_openBlock(), _createBlock(_component_v_col, {
                                              key: 4,
                                              class: "mx-4"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_row, null, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_col, null, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_oss_text_field_filled, {
                                                          modelValue: _ctx.contributionUniqueALaFormationRate,
                                                          "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.contributionUniqueALaFormationRate) = $event)),
                                                          disabled: _ctx.closedPeriod || _ctx.validated,
                                                          suffix: "%",
                                                          label: "Contr. Unique Formation",
                                                          class: "mx-auto",
                                                          "content-class": "text_field_tag",
                                                          autofocus: "",
                                                          onChange: _cache[38] || (_cache[38] = ($event: any) => (_ctx.changeTaxesProvision()))
                                                        }, null, 8, ["modelValue", "disabled"])
                                                      ]),
                                                      _: 1
                                                    }),
                                                    _createVNode(_component_v_col, { class: "d-flex justify-end align-center" }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(_ctx.newCommonFormatCurrency(
                                                    _ctx.contributionUniqueALaFormationAmount,
                                                    undefined,
                                                )), 1)
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            }))
                                          : (_openBlock(), _createBlock(_component_v_col, { key: 5 })),
                                        (_ctx.contributionEffortConstruction === true)
                                          ? (_openBlock(), _createBlock(_component_v_col, {
                                              key: 6,
                                              class: "ml-4"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_row, null, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_col, null, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_oss_text_field_filled, {
                                                          modelValue: _ctx.contributionEffortConstructionRate,
                                                          "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.contributionEffortConstructionRate) = $event)),
                                                          disabled: _ctx.closedPeriod || _ctx.validated,
                                                          suffix: "%",
                                                          label: "Contr. Effort Construct.",
                                                          class: "mx-auto",
                                                          "content-class": "text_field_tag",
                                                          autofocus: "",
                                                          onChange: _cache[40] || (_cache[40] = ($event: any) => (_ctx.changeTaxesProvision()))
                                                        }, null, 8, ["modelValue", "disabled"])
                                                      ]),
                                                      _: 1
                                                    }),
                                                    _createVNode(_component_v_col, { class: "d-flex justify-end align-center" }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(_ctx.newCommonFormatCurrency(
                                                    _ctx.contributionEffortConstructionAmount,
                                                    undefined,
                                                )), 1)
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            }))
                                          : (_openBlock(), _createBlock(_component_v_col, { key: 7 }))
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            _createVNode(_component_v_row, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, { class: "pb-5" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_card_title, {
                                      style: {"padding-top":"20px","padding-bottom":"0","padding-left":"0"},
                                      class: "d-flex justify-end"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_spacer),
                                        _createVNode(_component_v_btn, {
                                          disabled: _ctx.closedPeriod || _ctx.validatedTaxes || _ctx.validated,
                                          rounded: "",
                                          class: "btn btn_blue",
                                          onClick: _cache[41] || (_cache[41] = ($event: any) => (_ctx.miscellaneousOperationDialog = true)),
                                          size: "small"
                                        }, {
                                          default: _withCtx(() => _cache[101] || (_cache[101] = [
                                            _createTextVNode(" OD ")
                                          ])),
                                          _: 1
                                        }, 8, ["disabled"]),
                                        _createVNode(_component_v_btn, {
                                          disabled: _ctx.closedPeriod || _ctx.validatedTaxes || _ctx.validated,
                                          rounded: "",
                                          class: "btn btn_blue ml-2",
                                          onClick: _cache[42] || (_cache[42] = _withModifiers(($event: any) => (_ctx.dialog = true), ["stop"])),
                                          size: "small"
                                        }, {
                                          default: _withCtx(() => _cache[102] || (_cache[102] = [
                                            _createTextVNode(" Enregistrer ")
                                          ])),
                                          _: 1
                                        }, 8, ["disabled"]),
                                        (!_ctx.validatedTaxes)
                                          ? (_openBlock(), _createBlock(_component_v_btn, {
                                              key: 0,
                                              modelValue: _ctx.validatedTaxes,
                                              "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((_ctx.validatedTaxes) = $event)),
                                              disabled: _ctx.closedPeriod || _ctx.validated,
                                              rounded: "",
                                              class: "btn btn_blue ml-2",
                                              onClick: _cache[44] || (_cache[44] = ($event: any) => {
                                            _ctx.validatedTaxes = !_ctx.validatedTaxes;
                                            _ctx.createPaidHolidaysProvision('VALIDATE');
                                        }),
                                              size: "small"
                                            }, {
                                              default: _withCtx(() => _cache[103] || (_cache[103] = [
                                                _createTextVNode(" Valider les taxes ")
                                              ])),
                                              _: 1
                                            }, 8, ["modelValue", "disabled"]))
                                          : (_openBlock(), _createBlock(_component_v_btn, {
                                              key: 1,
                                              modelValue: _ctx.validatedTaxes,
                                              "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => ((_ctx.validatedTaxes) = $event)),
                                              disabled: _ctx.closedPeriod || _ctx.validated,
                                              rounded: "",
                                              class: "btn btn_blue ml-2",
                                              onClick: _cache[46] || (_cache[46] = ($event: any) => {
                                            _ctx.validatedTaxes = !_ctx.validatedTaxes;
                                            _ctx.createPaidHolidaysProvision('UPDATE');
                                        }),
                                              size: "small"
                                            }, {
                                              default: _withCtx(() => _cache[104] || (_cache[104] = [
                                                _createTextVNode(" Invalider les taxes ")
                                              ])),
                                              _: 1
                                            }, 8, ["modelValue", "disabled"]))
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 512), [
                          [_vShow, _ctx.showTaxes]
                        ])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (!_ctx.loading && !_ctx.dataLoading)
                  ? (_openBlock(), _createBlock(_component_AuditConnectedAcrDocuments, {
                      key: 5,
                      connectedDocuments: _ctx.connectedDocuments,
                      companyId: _ctx.companyId,
                      acKey: _ctx.acKey,
                      auditCheckResult: _ctx.auditCheckResult || {},
                      accountingPeriodId: _ctx.accountingPeriod.id || undefined,
                      onUnlinkedDocument: _cache[47] || (_cache[47] = ($event: any) => (_ctx.unlinkDocument($event))),
                      onShowLinkedDocument: _cache[48] || (_cache[48] = ($event: any) => (_ctx.showLinkedDocument($event)))
                    }, null, 8, ["connectedDocuments", "companyId", "acKey", "auditCheckResult", "accountingPeriodId"]))
                  : _createCommentVNode("", true),
                (!_ctx.loading && !_ctx.dataLoading)
                  ? (_openBlock(), _createBlock(_component_AuditConnectedAcrResults, {
                      key: 6,
                      results: _ctx.results,
                      companyId: _ctx.companyId
                    }, null, 8, ["results", "companyId"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_v_card, {
                  elevation: "0",
                  style: {"background-color":"white","border-radius":"25px"},
                  class: "pa-6 mt-4"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          cols: "11",
                          class: "ma-auto"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_card_title, { class: "ma-0 pa-0" }, {
                              default: _withCtx(() => _cache[105] || (_cache[105] = [
                                _createElementVNode("h5", { class: "pl-4" }, "Commentaires détaillés", -1)
                              ])),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, {
                          cols: "1",
                          class: "d-flex align-center px-0 justify-center"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_row, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, { cols: "6" }),
                                _createVNode(_component_v_col, {
                                  cols: "6",
                                  class: "d-flex align-center pa-0"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_btn_icon, {
                                      icon: 
                                            _ctx.longCommentExpand
                                                ? '$fa-chevron-up'
                                                : '$fa-chevron-down'
                                        ,
                                      onClick: _cache[49] || (_cache[49] = ($event: any) => (_ctx.longCommentExpand = !_ctx.longCommentExpand)),
                                      style: {"width":"40px"},
                                      class: "d-inline px-2"
                                    }, null, 8, ["icon"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    (_ctx.longCommentExpand)
                      ? (_openBlock(), _createBlock(_component_v_card_text, {
                          key: 0,
                          transition: "longCommentExpand"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_card_text, { class: "px-4" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_textarea, {
                                  modelValue: _ctx.longComment,
                                  "onUpdate:modelValue": _cache[50] || (_cache[50] = ($event: any) => ((_ctx.longComment) = $event)),
                                  disabled: _ctx.closedPeriod || _ctx.validated,
                                  "auto-grow": "",
                                  style: {"border":"1px #ededed solid"}
                                }, null, 8, ["modelValue", "disabled"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_row, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, { style: {"padding-bottom":"0"} }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_card_title, { style: {"padding-top":"20px","padding-bottom":"0","padding-left":"0"} }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_spacer),
                                        _createVNode(_component_v_btn, {
                                          disabled: _ctx.closedPeriod || _ctx.validated,
                                          rounded: "",
                                          class: "btn btn_blue",
                                          onClick: _cache[51] || (_cache[51] = _withModifiers(($event: any) => (_ctx.createPaidHolidaysProvision()), ["stop"])),
                                          size: "small"
                                        }, {
                                          default: _withCtx(() => _cache[106] || (_cache[106] = [
                                            _createTextVNode(" Enregistrer ")
                                          ])),
                                          _: 1
                                        }, 8, ["disabled"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card, {
                  elevation: "0",
                  style: {"background-color":"white","border-radius":"25px"},
                  class: "pa-6 mt-4"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          cols: "11",
                          class: "ma-auto"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_card_title, { class: "ma-0 pa-0" }, {
                              default: _withCtx(() => _cache[107] || (_cache[107] = [
                                _createElementVNode("h5", { class: "pl-4" }, "Commentaires synthétiques", -1)
                              ])),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, {
                          cols: "1",
                          class: "d-flex align-center px-0 justify-center"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_row, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, { cols: "6" }),
                                _createVNode(_component_v_col, {
                                  cols: "6",
                                  class: "d-flex align-center pa-0"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_btn_icon, {
                                      icon: 
                                            _ctx.shortCommentExpand
                                                ? '$fa-chevron-up'
                                                : '$fa-chevron-down'
                                        ,
                                      onClick: _cache[52] || (_cache[52] = ($event: any) => (_ctx.shortCommentExpand = !_ctx.shortCommentExpand)),
                                      style: {"width":"40px"},
                                      class: "d-inline px-2"
                                    }, null, 8, ["icon"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    (_ctx.shortCommentExpand)
                      ? (_openBlock(), _createBlock(_component_v_card_text, {
                          key: 0,
                          transition: "shortCommentExpand"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_card_text, { class: "px-4" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_textarea, {
                                  modelValue: _ctx.shortComment,
                                  "onUpdate:modelValue": _cache[53] || (_cache[53] = ($event: any) => ((_ctx.shortComment) = $event)),
                                  disabled: _ctx.closedPeriod || _ctx.validated,
                                  "auto-grow": "",
                                  style: {"border":"1px #ededed solid"}
                                }, null, 8, ["modelValue", "disabled"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_row, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, { style: {"padding-bottom":"0"} }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_card_title, { style: {"padding-top":"20px","padding-bottom":"0","padding-left":"0"} }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_spacer),
                                        _createVNode(_component_v_btn, {
                                          disabled: _ctx.closedPeriod || _ctx.validated,
                                          rounded: "",
                                          class: "btn btn_blue",
                                          onClick: _cache[54] || (_cache[54] = _withModifiers(($event: any) => (_ctx.createPaidHolidaysProvision()), ["stop"])),
                                          size: "small"
                                        }, {
                                          default: _withCtx(() => _cache[108] || (_cache[108] = [
                                            _createTextVNode(" Enregistrer ")
                                          ])),
                                          _: 1
                                        }, 8, ["disabled"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card, {
                  elevation: "0",
                  style: {"background-color":"white","border-radius":"25px"},
                  class: "pa-6 mt-4"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          cols: "11",
                          class: "ma-auto"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_card_title, { class: "ma-0 pa-0" }, {
                              default: _withCtx(() => [
                                _createElementVNode("h5", _hoisted_61, " Grand livre - c/" + _toDisplayString(_ctx.getTextFromStringArray(_ctx.auditItems.othersAccountableAccounts)) + " " + _toDisplayString(_ctx.auditItems.excludedOthersAccountableAccounts &&
                                        _ctx.auditItems.excludedOthersAccountableAccounts.length
                                            ? `(sauf ${_ctx.getTextFromStringArray(
                                                  _ctx.auditItems.excludedOthersAccountableAccounts,
                                              )}`
                                            : ""), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, {
                          cols: "1",
                          class: "d-flex align-center px-0 justify-center"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_row, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, { cols: "6" }),
                                _createVNode(_component_v_col, {
                                  cols: "6",
                                  class: "d-flex align-center pa-0"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_btn_icon, {
                                      icon: 
                                            _ctx.showGeneralLedger
                                                ? '$fa-chevron-up'
                                                : '$fa-chevron-down'
                                        ,
                                      onClick: _cache[55] || (_cache[55] = ($event: any) => (_ctx.showGeneralLedger = !_ctx.showGeneralLedger)),
                                      style: {"width":"40px"},
                                      class: "d-inline px-2"
                                    }, null, 8, ["icon"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_expand_transition, null, {
                      default: _withCtx(() => [
                        _withDirectives(_createElementVNode("div", null, [
                          _createVNode(_component_v_row, { class: "pt-2" }, {
                            default: _withCtx(() => [
                              (_openBlock(), _createBlock(_component_v_col, {
                                style: {"padding-top":"0","padding-bottom":"0"},
                                key: _ctx.refreshGeneralLedger
                              }, {
                                default: _withCtx(() => [
                                  (_ctx.accountingPeriod.id)
                                    ? (_openBlock(), _createBlock(_component_GeneralLedger, {
                                        key: 0,
                                        companyId: _ctx.companyId,
                                        accountingPeriodId: _ctx.accountingPeriod.id,
                                        hideOptions: false,
                                        accountableAccountFilter: 
                                            _ctx.auditItems.othersAccountableAccounts || []
                                        ,
                                        excludedAccountableAccounts: 
                                            _ctx.auditItems.excludedOthersAccountableAccounts || []
                                        ,
                                        refreshCount: _ctx.refreshGeneralLedger
                                      }, null, 8, ["companyId", "accountingPeriodId", "accountableAccountFilter", "excludedAccountableAccounts", "refreshCount"]))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 1
                              }))
                            ]),
                            _: 1
                          })
                        ], 512), [
                          [_vShow, _ctx.showGeneralLedger]
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                (_ctx.dialog)
                  ? (_openBlock(), _createBlock(_component_oss_dialog, {
                      key: 7,
                      modelValue: _ctx.dialog,
                      "onUpdate:modelValue": _cache[57] || (_cache[57] = ($event: any) => ((_ctx.dialog) = $event)),
                      persistent: "",
                      "min-width": "90vw",
                      onValid: _cache[58] || (_cache[58] = ($event: any) => (_ctx.createPaidHolidaysProvision())),
                      onClose: _ctx.closeDialog
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_card, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_card_text, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_container, null, {
                                  default: _withCtx(() => [
                                    (_ctx.wagesCond)
                                      ? (_openBlock(), _createElementBlock("h1", _hoisted_62, " PROVISIONS SUR SALAIRES "))
                                      : (_openBlock(), _createElementBlock("h2", {
                                          key: 1,
                                          style: _normalizeStyle(_ctx.styleDialogNoProvision)
                                        }, " Aucune Provision s/Salaires ", 4)),
                                    (_ctx.wagesCond)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                                          _createVNode(_component_v_divider),
                                          (_ctx.bookEntries.grossWageProvision.amount > 0)
                                            ? (_openBlock(), _createElementBlock("h2", {
                                                key: 0,
                                                style: _normalizeStyle(_ctx.styleDialogProvision)
                                              }, " Provisions pour congés payés et RTT ", 4))
                                            : (_openBlock(), _createElementBlock("h3", {
                                                key: 1,
                                                style: _normalizeStyle(_ctx.styleDialogNoProvision)
                                              }, " Aucune provision pour congés payés et RTT ", 4)),
                                          (_ctx.bookEntries.grossWageProvision.amount > 0)
                                            ? (_openBlock(), _createBlock(_component_v_row, {
                                                key: 2,
                                                "no-gutters": ""
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_col, {
                                                    style: _normalizeStyle(_ctx.styleDialogCol)
                                                  }, {
                                                    default: _withCtx(() => _cache[109] || (_cache[109] = [
                                                      _createTextVNode(" Salaire Brut ")
                                                    ])),
                                                    _: 1
                                                  }, 8, ["style"]),
                                                  _createVNode(_component_v_col, {
                                                    style: _normalizeStyle(_ctx.styleDialogCol)
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode(_toDisplayString(_ctx.bookEntries.grossWageProvision
                                                    .accountableAccountName) + " à " + _toDisplayString(_ctx.bookEntries.grossWageProvision
                                                    .thirdPartyAccountableAccountName), 1)
                                                    ]),
                                                    _: 1
                                                  }, 8, ["style"]),
                                                  _createVNode(_component_v_col, {
                                                    style: _normalizeStyle(_ctx.styleDialogCol)
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode(_toDisplayString(_ctx.newCommonFormatCurrency(
                                                    _ctx.bookEntries.grossWageProvision.amount,
                                                    undefined,
                                                )), 1)
                                                    ]),
                                                    _: 1
                                                  }, 8, ["style"])
                                                ]),
                                                _: 1
                                              }))
                                            : _createCommentVNode("", true),
                                          (_ctx.bookEntries.employerContribProvOnGrossWage.amount > 0)
                                            ? (_openBlock(), _createBlock(_component_v_row, {
                                                key: 3,
                                                "no-gutters": ""
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_col, {
                                                    style: _normalizeStyle(_ctx.styleDialogCol)
                                                  }, {
                                                    default: _withCtx(() => _cache[110] || (_cache[110] = [
                                                      _createTextVNode(" Cotisations patronales ")
                                                    ])),
                                                    _: 1
                                                  }, 8, ["style"]),
                                                  _createVNode(_component_v_col, {
                                                    style: _normalizeStyle(_ctx.styleDialogCol)
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode(_toDisplayString(_ctx.bookEntries.employerContribProvOnGrossWage
                                                    .accountableAccountName) + " à " + _toDisplayString(_ctx.bookEntries.employerContribProvOnGrossWage
                                                    .thirdPartyAccountableAccountName), 1)
                                                    ]),
                                                    _: 1
                                                  }, 8, ["style"]),
                                                  _createVNode(_component_v_col, {
                                                    style: _normalizeStyle(_ctx.styleDialogCol)
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode(_toDisplayString(_ctx.newCommonFormatCurrency(
                                                    _ctx.bookEntries.employerContribProvOnGrossWage
                                                        .amount,
                                                    undefined,
                                                )), 1)
                                                    ]),
                                                    _: 1
                                                  }, 8, ["style"])
                                                ]),
                                                _: 1
                                              }))
                                            : _createCommentVNode("", true)
                                        ]))
                                      : _createCommentVNode("", true),
                                    (_ctx.bookEntries.bonusGrossSalary.amount > 0)
                                      ? (_openBlock(), _createElementBlock("h2", {
                                          key: 3,
                                          style: _normalizeStyle(_ctx.styleDialogProvision)
                                        }, " Provisions sur primes ", 4))
                                      : (_openBlock(), _createElementBlock("h3", {
                                          key: 4,
                                          style: _normalizeStyle(_ctx.styleDialogNoProvision)
                                        }, " Aucune provision sur primes ", 4)),
                                    (_ctx.bookEntries.bonusGrossSalary.amount > 0)
                                      ? (_openBlock(), _createBlock(_component_v_row, {
                                          key: 5,
                                          "no-gutters": ""
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_col, {
                                              style: _normalizeStyle(_ctx.styleDialogCol)
                                            }, {
                                              default: _withCtx(() => _cache[111] || (_cache[111] = [
                                                _createTextVNode(" Salaire brut ")
                                              ])),
                                              _: 1
                                            }, 8, ["style"]),
                                            _createVNode(_component_v_col, {
                                              style: _normalizeStyle(_ctx.styleDialogCol)
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.bookEntries.bonusGrossSalary.accountableAccountName) + " à " + _toDisplayString(_ctx.bookEntries.bonusGrossSalary
                                                .thirdPartyAccountableAccountName), 1)
                                              ]),
                                              _: 1
                                            }, 8, ["style"]),
                                            _createVNode(_component_v_col, {
                                              style: _normalizeStyle(_ctx.styleDialogCol)
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.newCommonFormatCurrency(
                                                _ctx.bookEntries.bonusGrossSalary.amount,
                                                undefined,
                                            )), 1)
                                              ]),
                                              _: 1
                                            }, 8, ["style"])
                                          ]),
                                          _: 1
                                        }))
                                      : _createCommentVNode("", true),
                                    (_ctx.bookEntries.employerContribProvOnBonus.amount > 0)
                                      ? (_openBlock(), _createBlock(_component_v_row, {
                                          key: 6,
                                          "no-gutters": ""
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_col, {
                                              style: _normalizeStyle(_ctx.styleDialogCol)
                                            }, {
                                              default: _withCtx(() => _cache[112] || (_cache[112] = [
                                                _createTextVNode(" Cotisations patronales ")
                                              ])),
                                              _: 1
                                            }, 8, ["style"]),
                                            _createVNode(_component_v_col, {
                                              style: _normalizeStyle(_ctx.styleDialogCol)
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.bookEntries.employerContribProvOnBonus
                                                .accountableAccountName) + " à " + _toDisplayString(_ctx.bookEntries.employerContribProvOnBonus
                                                .thirdPartyAccountableAccountName), 1)
                                              ]),
                                              _: 1
                                            }, 8, ["style"]),
                                            _createVNode(_component_v_col, {
                                              style: _normalizeStyle(_ctx.styleDialogCol)
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.newCommonFormatCurrency(
                                                _ctx.bookEntries.employerContribProvOnBonus.amount,
                                                undefined,
                                            )), 1)
                                              ]),
                                              _: 1
                                            }, 8, ["style"])
                                          ]),
                                          _: 1
                                        }))
                                      : _createCommentVNode("", true),
                                    _createVNode(_component_v_divider, {
                                      style: _normalizeStyle(_ctx.styleDialogDivider)
                                    }, null, 8, ["style"]),
                                    (_ctx.taxesCond)
                                      ? (_openBlock(), _createElementBlock("h1", _hoisted_64, " TAXES SUR SALAIRES "))
                                      : _createCommentVNode("", true),
                                    (_ctx.taxesCond)
                                      ? (_openBlock(), _createElementBlock("h3", _hoisted_65, " Base : SB Annuel - SB apprentis "))
                                      : (_openBlock(), _createElementBlock("h2", _hoisted_66, "Aucune Taxe s/Salaires")),
                                    (_ctx.taxesCond)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
                                          _createVNode(_component_v_divider, {
                                            style: _normalizeStyle(_ctx.styleDialogDivider)
                                          }, null, 8, ["style"]),
                                          (_ctx.bookEntries.taxeApprentissage.amount > 0)
                                            ? (_openBlock(), _createElementBlock("h2", {
                                                key: 0,
                                                style: _normalizeStyle(_ctx.styleDialogProvision)
                                              }, " Provisions sur taxe d'apprentissage ", 4))
                                            : (_openBlock(), _createElementBlock("h3", {
                                                key: 1,
                                                style: _normalizeStyle(_ctx.styleDialogNoProvision)
                                              }, " Aucune provision sur taxe d'apprentissage ", 4)),
                                          (_ctx.bookEntries.taxeApprentissage.amount > 0)
                                            ? (_openBlock(), _createBlock(_component_v_row, {
                                                key: 2,
                                                "no-gutters": ""
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_col, {
                                                    style: _normalizeStyle(_ctx.styleDialogCol)
                                                  }, null, 8, ["style"]),
                                                  _createVNode(_component_v_col, {
                                                    style: _normalizeStyle(_ctx.styleDialogCol)
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode(_toDisplayString(_ctx.bookEntries.taxeApprentissage.accountableAccountName) + " à " + _toDisplayString(_ctx.bookEntries.taxeApprentissage
                                                    .thirdPartyAccountableAccountName), 1)
                                                    ]),
                                                    _: 1
                                                  }, 8, ["style"]),
                                                  _createVNode(_component_v_col, {
                                                    style: _normalizeStyle(_ctx.styleDialogCol)
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode(_toDisplayString(_ctx.newCommonFormatCurrency(
                                                    _ctx.bookEntries.taxeApprentissage.amount,
                                                    undefined,
                                                )), 1)
                                                    ]),
                                                    _: 1
                                                  }, 8, ["style"])
                                                ]),
                                                _: 1
                                              }))
                                            : _createCommentVNode("", true),
                                          _createVNode(_component_v_divider, {
                                            style: _normalizeStyle(_ctx.styleDialogDivider)
                                          }, null, 8, ["style"]),
                                          (
                                            _ctx.bookEntries.contributionSupplementaireALApprentissage
                                                .amount > 0
                                        )
                                            ? (_openBlock(), _createElementBlock("h2", {
                                                key: 3,
                                                style: _normalizeStyle(_ctx.styleDialogProvision)
                                              }, " Provisions sur la Contribution Supplementaire à l'Apprentissage ", 4))
                                            : (_openBlock(), _createElementBlock("h3", {
                                                key: 4,
                                                style: _normalizeStyle(_ctx.styleDialogNoProvision)
                                              }, " Aucune provision sur la Contribution Supplementaire à l'Apprentissage ", 4)),
                                          (
                                            _ctx.bookEntries.contributionSupplementaireALApprentissage
                                                .amount > 0
                                        )
                                            ? (_openBlock(), _createBlock(_component_v_row, {
                                                key: 5,
                                                "no-gutters": ""
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_col, {
                                                    style: _normalizeStyle(_ctx.styleDialogCol)
                                                  }, null, 8, ["style"]),
                                                  _createVNode(_component_v_col, {
                                                    style: _normalizeStyle(_ctx.styleDialogCol)
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode(_toDisplayString(_ctx.bookEntries
                                                    .contributionSupplementaireALApprentissage
                                                    .accountableAccountName) + " à " + _toDisplayString(_ctx.bookEntries
                                                    .contributionSupplementaireALApprentissage
                                                    .thirdPartyAccountableAccountName), 1)
                                                    ]),
                                                    _: 1
                                                  }, 8, ["style"]),
                                                  _createVNode(_component_v_col, {
                                                    style: _normalizeStyle(_ctx.styleDialogCol)
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode(_toDisplayString(_ctx.newCommonFormatCurrency(
                                                    _ctx.bookEntries
                                                        .contributionSupplementaireALApprentissage
                                                        .amount,
                                                    undefined,
                                                )), 1)
                                                    ]),
                                                    _: 1
                                                  }, 8, ["style"])
                                                ]),
                                                _: 1
                                              }))
                                            : _createCommentVNode("", true),
                                          _createVNode(_component_v_divider, {
                                            style: _normalizeStyle(_ctx.styleDialogDivider)
                                          }, null, 8, ["style"]),
                                          (_ctx.bookEntries.taxeSurLesSalaires.amount > 0)
                                            ? (_openBlock(), _createElementBlock("h2", {
                                                key: 6,
                                                style: _normalizeStyle(_ctx.styleDialogProvision)
                                              }, " Provisions sur taxe sur les salaires ", 4))
                                            : (_openBlock(), _createElementBlock("h3", {
                                                key: 7,
                                                style: _normalizeStyle(_ctx.styleDialogNoProvision)
                                              }, " Aucune provision sur taxe sur les salaires ", 4)),
                                          (_ctx.bookEntries.taxeSurLesSalaires.amount > 0)
                                            ? (_openBlock(), _createBlock(_component_v_row, {
                                                key: 8,
                                                "no-gutters": ""
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_col, {
                                                    style: _normalizeStyle(_ctx.styleDialogCol)
                                                  }, null, 8, ["style"]),
                                                  _createVNode(_component_v_col, {
                                                    style: _normalizeStyle(_ctx.styleDialogCol)
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode(_toDisplayString(_ctx.bookEntries.taxeSurLesSalaires
                                                    .accountableAccountName) + " à " + _toDisplayString(_ctx.bookEntries.taxeSurLesSalaires
                                                    .thirdPartyAccountableAccountName), 1)
                                                    ]),
                                                    _: 1
                                                  }, 8, ["style"]),
                                                  _createVNode(_component_v_col, {
                                                    style: _normalizeStyle(_ctx.styleDialogCol)
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode(_toDisplayString(_ctx.newCommonFormatCurrency(
                                                    _ctx.bookEntries.taxeSurLesSalaires.amount,
                                                    undefined,
                                                )), 1)
                                                    ]),
                                                    _: 1
                                                  }, 8, ["style"])
                                                ]),
                                                _: 1
                                              }))
                                            : _createCommentVNode("", true),
                                          _createVNode(_component_v_divider, {
                                            style: _normalizeStyle(_ctx.styleDialogDivider)
                                          }, null, 8, ["style"]),
                                          (_ctx.bookEntries.contributionUniqueALaFormation.amount > 0)
                                            ? (_openBlock(), _createElementBlock("h2", {
                                                key: 9,
                                                style: _normalizeStyle(_ctx.styleDialogProvision)
                                              }, " Provisions sur la Contribution Unique à la Formation ", 4))
                                            : (_openBlock(), _createElementBlock("h3", {
                                                key: 10,
                                                style: _normalizeStyle(_ctx.styleDialogNoProvision)
                                              }, " Aucune provision sur la Contribution Unique à la Formation ", 4)),
                                          (_ctx.bookEntries.contributionUniqueALaFormation.amount > 0)
                                            ? (_openBlock(), _createBlock(_component_v_row, {
                                                key: 11,
                                                "no-gutters": ""
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_col, {
                                                    style: _normalizeStyle(_ctx.styleDialogCol)
                                                  }, null, 8, ["style"]),
                                                  _createVNode(_component_v_col, {
                                                    style: _normalizeStyle(_ctx.styleDialogCol)
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode(_toDisplayString(_ctx.bookEntries.contributionUniqueALaFormation
                                                    .accountableAccountName) + " + 445860 à " + _toDisplayString(_ctx.bookEntries.contributionUniqueALaFormation
                                                    .thirdPartyAccountableAccountName), 1)
                                                    ]),
                                                    _: 1
                                                  }, 8, ["style"]),
                                                  _createVNode(_component_v_col, {
                                                    style: _normalizeStyle(_ctx.styleDialogCol)
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode(_toDisplayString(_ctx.newCommonFormatCurrency(
                                                    _ctx.bookEntries.contributionUniqueALaFormation
                                                        .amount,
                                                    undefined,
                                                )) + " HT + " + _toDisplayString(_ctx.newCommonFormatCurrency(
                                                    _ctx.bookEntries.contributionUniqueALaFormation
                                                        .vatAmount,
                                                    undefined,
                                                )) + " TVA à " + _toDisplayString(_ctx.newCommonFormatCurrency(
                                                    _ctx.bookEntries.contributionUniqueALaFormation
                                                        .grossAmount,
                                                    undefined,
                                                )) + " TTC ", 1)
                                                    ]),
                                                    _: 1
                                                  }, 8, ["style"])
                                                ]),
                                                _: 1
                                              }))
                                            : _createCommentVNode("", true),
                                          _createVNode(_component_v_divider, {
                                            style: _normalizeStyle(_ctx.styleDialogDivider)
                                          }, null, 8, ["style"]),
                                          (_ctx.bookEntries.contributionEffortConstruction.amount > 0)
                                            ? (_openBlock(), _createElementBlock("h2", {
                                                key: 12,
                                                style: _normalizeStyle(_ctx.styleDialogProvision)
                                              }, " Provisions sur taxe d'apprentissage ", 4))
                                            : (_openBlock(), _createElementBlock("h3", {
                                                key: 13,
                                                style: _normalizeStyle(_ctx.styleDialogNoProvision)
                                              }, " Aucune provision sur la Contribution à l'Effort de la Construction ", 4)),
                                          (_ctx.bookEntries.contributionEffortConstruction.amount > 0)
                                            ? (_openBlock(), _createBlock(_component_v_row, {
                                                key: 14,
                                                "no-gutters": ""
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_col, {
                                                    style: _normalizeStyle(_ctx.styleDialogCol)
                                                  }, null, 8, ["style"]),
                                                  _createVNode(_component_v_col, {
                                                    style: _normalizeStyle(_ctx.styleDialogCol)
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode(_toDisplayString(_ctx.bookEntries.contributionEffortConstruction
                                                    .accountableAccountName) + " à " + _toDisplayString(_ctx.bookEntries.contributionEffortConstruction
                                                    .thirdPartyAccountableAccountName), 1)
                                                    ]),
                                                    _: 1
                                                  }, 8, ["style"]),
                                                  _createVNode(_component_v_col, {
                                                    style: _normalizeStyle(_ctx.styleDialogCol)
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode(_toDisplayString(_ctx.newCommonFormatCurrency(
                                                    _ctx.bookEntries.contributionEffortConstruction
                                                        .amount,
                                                    undefined,
                                                )), 1)
                                                    ]),
                                                    _: 1
                                                  }, 8, ["style"])
                                                ]),
                                                _: 1
                                              }))
                                            : _createCommentVNode("", true)
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_card_actions, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_spacer),
                                _createVNode(_component_v_btn, {
                                  rounded: "",
                                  depressed: "",
                                  onClick: _ctx.closeDialog
                                }, {
                                  default: _withCtx(() => _cache[113] || (_cache[113] = [
                                    _createTextVNode(" Annuler ")
                                  ])),
                                  _: 1
                                }, 8, ["onClick"]),
                                _createVNode(_component_v_btn, {
                                  rounded: "",
                                  depressed: "",
                                  onClick: _cache[56] || (_cache[56] = ($event: any) => (_ctx.createPaidHolidaysProvision()))
                                }, {
                                  default: _withCtx(() => _cache[114] || (_cache[114] = [
                                    _createTextVNode(" Enregistrer ")
                                  ])),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue", "onClose"]))
                  : _createCommentVNode("", true),
                (_ctx.displayActivityDialog)
                  ? (_openBlock(), _createBlock(_component_oss_dialog, {
                      key: 8,
                      modelValue: _ctx.displayActivityDialog,
                      "onUpdate:modelValue": _cache[59] || (_cache[59] = ($event: any) => ((_ctx.displayActivityDialog) = $event)),
                      title: "Activité",
                      "valid-title": "Fermer",
                      onValid: _cache[60] || (_cache[60] = ($event: any) => (_ctx.displayActivityDialog = false)),
                      onClose: _cache[61] || (_cache[61] = ($event: any) => (_ctx.displayActivityDialog = false)),
                      "min-width": "60vw"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_UsersActivitiesHistory, {
                          auditCheckKey: _ctx.acKey,
                          accountingPeriodId: _ctx.accountingPeriodId
                        }, null, 8, ["auditCheckKey", "accountingPeriodId"])
                      ]),
                      _: 1
                    }, 8, ["modelValue"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_oss_dialog, {
                  modelValue: _ctx.miscellaneousOperationDialog,
                  "onUpdate:modelValue": _cache[63] || (_cache[63] = ($event: any) => ((_ctx.miscellaneousOperationDialog) = $event)),
                  actions: _ctx.actionsMiscellaneousOperation,
                  "min-width": "90vw"
                }, {
                  default: _withCtx(() => [
                    (_ctx.miscellaneousOperationDialog)
                      ? (_openBlock(), _createBlock(_component_AccountingItemEdition2, {
                          key: 0,
                          companyId: _ctx.companyId,
                          acKey: _ctx.acKey,
                          auditCheckResult: _ctx.auditCheckResult,
                          accountingPeriodId: _ctx.accountingPeriodId,
                          onUpsert: _cache[62] || (_cache[62] = ($event: any) => (_ctx.refresh())),
                          actions: _ctx.actionsMiscellaneousOperation
                        }, null, 8, ["companyId", "acKey", "auditCheckResult", "accountingPeriodId", "actions"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["modelValue", "actions"]),
                (_ctx.openChat)
                  ? (_openBlock(), _createBlock(_component_Chat, {
                      key: 9,
                      auditCheckAccountingPeriodKey: _ctx.chatId,
                      chatTitle: 'Chat'
                    }, null, 8, ["auditCheckAccountingPeriodKey"]))
                  : _createCommentVNode("", true),
                (_ctx.dialogAuditCheckDocumentsManager)
                  ? (_openBlock(), _createBlock(_component_AuditCheckDocumentsManager, {
                      key: 10,
                      modelValue: _ctx.dialogAuditCheckDocumentsManager,
                      "onUpdate:modelValue": _cache[64] || (_cache[64] = ($event: any) => ((_ctx.dialogAuditCheckDocumentsManager) = $event)),
                      disabled: _ctx.loading || _ctx.dataLoading || !_ctx.accountingPeriod,
                      companyId: _ctx.companyId,
                      documentToDisplay: _ctx.documentToDisplay,
                      connectedDocuments: _ctx.connectedDocuments || [],
                      acKey: _ctx.acKey,
                      auditCheckResult: _ctx.auditCheckResult || {},
                      accountingPeriodId: _ctx.accountingPeriodId || undefined,
                      alreadyLinkedDoc: _ctx.alreadyLinkedDoc,
                      onUpsertedAuditCheckResult: _ctx.upsertedACR,
                      onResetDialogData: _cache[65] || (_cache[65] = ($event: any) => {
                        _ctx.alreadyLinkedDoc = false;
                        _ctx.documentToDisplay = {};
                    })
                    }, null, 8, ["modelValue", "disabled", "companyId", "documentToDisplay", "connectedDocuments", "acKey", "auditCheckResult", "accountingPeriodId", "alreadyLinkedDoc", "onUpsertedAuditCheckResult"]))
                  : _createCommentVNode("", true)
              ], 64))
      ])
    ]),
    _: 1
  }))
}